import * as React from 'react';

import styles from './title.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

Title.defaultProps = {
    as: 'div',
};

export function Title({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles.title}>{children}</Tag>;
}
